import React, { useState } from "react";
import { Button, Form, Input, Row, Modal, Spin, message, Radio } from "antd";
import coal from "./extraction-2781679_1280.jpg";
import favicon from "./favicon.ico";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { userLogin } from "../../Services/Services";
import { Box, Typography } from "@mui/material";
import {
  storeToken,
  storeResponse,
  removeToken,
} from "../../Services/LocalStorageService";

const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const response = await userLogin(values);
    setLoading(false);

    if (response.token) {
      removeToken();
      storeToken(response.token);
      storeResponse(response.user);
      setIsAuthenticated(true);
      navigate("/dashboard");
    } else {
      message.open({
        type: "error",
        content: response.errors,
      });
    }
  };

  return (
    <>
      <Modal
        open={loading}
        footer={null}
        closable={false}
        width={200}
        style={{ textAlign: "center" }}
      >
        <h2>
          <b>Login.....</b>
        </h2>
        <Spin />
      </Modal>
      <div
        className="login_main_container"
        style={{
          backgroundImage: `url(${coal})`,
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(41, 39, 39, 0.6)",
            zIndex: 1,
          }}
        ></div>

        {/* Form container */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            maxWidth: "500px",
            padding: "20px",
            // border: "1px solid #ce1818ff",
            background: "rgba(255, 255, 255, 0.1)", // semi-transparent background
            backdropFilter: "blur(8px)", // makes background blurry
            WebkitBackdropFilter: "blur(8px)", // for Safari
          }}
        >
          <Form
            name="login-form"
            requiredMark={false}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            style={{
              background: "transparent",
              borderRadius: "10px",
            }}
            layout="vertical"
          >
            {/* PRIYANSHI Coal Feeder Title */}
            <div style={{ marginBottom: "15px", textAlign: "center" }}>
              <b style={{ color: "white", fontSize: "27px" }}>
                PRIYANSHI COAL FEADER PVT. LTD.
              </b>
            </div>

            {/* Email */}
            <Form.Item
              name="email"
              label={
                <b
                  style={{
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "330",
                  }}
                >
                  Email Address
                </b>
              }
              rules={[
                { type: "email", message: "The input is not valid E-mail!" },
                { required: true, message: "Please input your E-mail!" },
              ]}
            >
              <Input
                placeholder="Enter Your Email"
                style={{
                  borderRadius: 0,
                  height: "50px",
                  backgroundColor: "transparent",
                  color: "white",
                }}
              />
            </Form.Item>

            {/* Password */}
            <Form.Item
              name="password"
              label={
                <b
                  style={{
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "330",
                  }}
                >
                  Password
                </b>
              }
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password
                placeholder="Password"
                style={{
                  borderRadius: 0,
                  height: "50px",
                  backgroundColor: "transparent",
                  color: "white",
                }}
                className="custom-password"
              />
            </Form.Item>

            {/* Company select (horizontal) */}
            <Form.Item
              name="com_name"
              label={
                <b
                  style={{
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "330",
                  }}
                >
                  Select
                </b>
              }
              rules={[{ required: true, message: "Please Select!" }]}
            >
              <Radio.Group defaultValue="">
                <Radio value="priyanshi">
                  <b
                    style={{
                      color: "white",
                      fontSize: "13px",
                      fontWeight: "400",
                    }}
                  >
                    PRIYANSHI COAL FEADER PVT. LTD.
                  </b>
                </Radio>
                <Radio value="kamal">
                  <b
                    style={{
                      color: "white",
                      fontSize: "13px",
                      fontWeight: "400",
                    }}
                  >
                    KAMAL TRADING COMPANY
                  </b>
                </Radio>
              </Radio.Group>
            </Form.Item>

            {/* Submit button */}
            <Form.Item style={{ textAlign: "center" }}>
              <Button
                style={{
                  color: "white",
                  fontWeight: "400",
                  width: "100%",
                  height: "40px",
                  borderRadius: 0,
                  background:
                    "linear-gradient(to right, rgb(66, 103, 178), rgb(225, 48, 108))",
                  fontSize: "17px",
                }}
                htmlType="submit"
              >
                Log in
              </Button>
            </Form.Item>

            {/* Footer */}
            <Box
              sx={{
                mt: 2,
                bgcolor: "rgba(46, 45, 45, 0.6)",
                p: 1,
                borderRadius: 1,
              }}
            >
              <Typography
                variant="body2"
                align="center"
                fontWeight={400}
                sx={{ color: "white", height: "40px", paddingTop: 1 }}
              >
                Powered By:{" "}
                <a
                  href="https://www.yashvitech.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                    padding: 0,
                  }}
                >
                  YASHVITECH IT SOLUTION PVT. LTD.
                </a>
              </Typography>
            </Box>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
